import React, {
    Component,
    PropTypes
} from 'react';
var className = "dark";
var newCount = 1;
import  {bumpUrl}from '../../../path.config'
import {language, resultTip} from 'UTIL/common'
import bumpService from 'SERVICES/purifier/bump/bumpService'
import ZtreeInput from 'COMPONENT/form/ztreeInput'
import Tip from 'CONFIG/component/tip'
export default class MetaIndex extends Component {
    constructor(props) {
        super(props);
        this.getNodeTree = this.getNodeTree.bind(this);
        this.addHoverDom = this.addHoverDom.bind(this);
        this.removeHoverDom = this.removeHoverDom.bind(this);
        this.showRemoveBtn = this.showRemoveBtn.bind(this);
        this.beforeDrag = this.beforeDrag.bind(this);
        this.beforeEditName = this.beforeEditName.bind(this);
        this.beforeRemove = this.beforeRemove.bind(this);
        this.beforeRename = this.beforeRename.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.onRename = this.onRename.bind(this);
        this.getTime = this.getTime.bind(this);
        this.submit = this.submit.bind(this);
        this.submitAdd = this.submitAdd.bind(this);
        this.onClick = this.onClick.bind(this);
        this.state = {
            data: [],
            pageSize: 10,
            page: 1,
            total: 0,
            directions: [],
            dvcTypes: [],
            hexconverts: [],
            isEntitys: [],
            delRow: {},
            url: 'http://10.18.11.212:9001/columbia/',
            expandId: '',
        }
    };

    componentDidMount() {
        $("#id").attr('disabled',true)
        $("#parentId").attr('disabled',true)
        $("#level").attr('disabled',true)
        $("#idAdd").attr('disabled',true)
        $("#parentIdAdd").attr('disabled',true)
        $("#levelAdd").attr('disabled',true)
        this.getData();
    }

    getData() {

        bumpService.metaList().then(data => {
            const json = data.data;
            this.setState({
                directions: json.directions,
                dvcTypes: json.dvcTypes,
                hexconverts: json.hexconverts,
                isEntitys: json.isEntitys,
            })

            const nodeList = json.nodeVos;
            const roleList = [];
            for (const i in nodeList) {
                let arr = {
                    id: nodeList[i].id,
                    pId: nodeList[i].pId,
                    name: nodeList[i].name
                }
                roleList.push(arr);
            }
            this.setState({
                data: roleList
            });
            this.getNodeTree(roleList);
        })
    }

    getNodeTree(zNodes) {
        const setting = {
            view: {
                addHoverDom: this.addHoverDom,
                removeHoverDom: this.removeHoverDom,
                selectedMulti: false
            },
            edit: {
                enable: true,
                showRemoveBtn: this.showRemoveBtn,
            },
            data: {
                simpleData: {
                    enable: true
                }
            },
            callback: {
                beforeDrag: this.beforeDrag,
                beforeEditName: this.beforeEditName,
                beforeRemove: this.beforeRemove,
                beforeRename: this.beforeRename,
                onRemove: this.onRemove,
                onRename: this.onRename,
                onClick: this.onClick,
            }
        };
        $.fn.zTree.init($("#treeDemo"), setting, zNodes);
        if (this.state.expandId != '') {
            var treeObj = $.fn.zTree.getZTreeObj("treeDemo");
            var treenode = treeObj.getNodeByParam("id", this.state.expandId, null);
            treeObj.expandNode(treenode, true, false);
            treeObj.selectNode(treenode);
        }


    }

    onClick(event, treeId, treeNode) {
        if (treeNode.id < 100000) {
            $("#editDiv").removeClass("hidden");
            $("#addDiv").addClass("hidden");
            var id = treeNode.id;
            bumpService.metaGetList(id).then(data => {
                const json = data.data;
                json.code == undefined ? $("#code").val("") : $("#code").val(json.code);
                json.id == undefined ? $("#id").val("") : $("#id").val(json.id);
                json.parentId == undefined ? $("#parentId").val("") : $("#parentId").val(json.parentId);
                json.name == undefined ? $("#name").val("") : $("#name").val(json.name);
                json.level == undefined ? $("#level").val("") : $("#level").val(json.level);
                json.accuracy == undefined ? $("#accuracy").val("") : $("#accuracy").val(json.accuracy);
                json.byteNum == undefined ? $("#byteNum").val("") : $("#byteNum").val(json.byteNum);
                json.dvcTypeId == undefined ? $("#dvcTypeId").val(1) : $("#dvcTypeId").val(json.dvcTypeId);
                json.metaUnit == undefined ? $("#metaUnit").val("") : $("#metaUnit").val(json.metaUnit);
                json.isEntity == undefined ? $("#isEntity").val(1) : $("#isEntity").val(json.isEntity);
                json.value == undefined ? $("#value").val("") : $("#value").val(json.value);
                json.format == undefined ? $("#format").val("") : $("#format").val(json.format);
                json.deviationVal == undefined ? $("#deviationVal").val("") : $("#deviationVal").val(json.deviationVal);
                json.hasExp == undefined ? $("#hexConvert").val(1) : $("#hexConvert").val(json.hexConvert);
                json.linkSign == undefined ? $("#linkSign").val("") : $("#linkSign").val(json.linkSign);
            })
        } else {
            $("#editDiv").addClass("hidden");
            $("#addDiv").removeClass("hidden");
            $("#idAdd").val(treeNode.id);
            $("#nameAdd").val(treeNode.name);
            $("#levelAdd").val(treeNode.level);
            $("#parentIdAdd").val(treeNode.pId);
            $("#codeAdd").val("");
            $("#accuracyAdd").val("");
            $("#byteNumAdd").val("");
            $("#dvcTypeIdAdd").val(1);
            $("#metaUnitAdd").val("");
            $("#isEntityAdd").val(1);
            $("#formatAdd").val("");
            $("#deviationValAdd").val("");
            $("#hexConvertAdd").val(1);
            $("#linkSignAdd").val("");
            $("#valueAdd").val("");
        }
    }

    beforeDrag(treeId, treeNodes) {
        return false;
    }

    beforeEditName(treeId, treeNode) {
        const self = this;
        className = (className === "dark" ? "" : "dark");
        var zTree = $.fn.zTree.getZTreeObj("treeDemo");
        zTree.selectNode(treeNode);
        setTimeout(function () {
            if (confirm("进入节点 -- " + treeNode.name + " 的编辑状态吗？")) {
                if (treeNode.id < 100000) {
                    $("#editDiv").removeClass("hidden");
                    $("#addDiv").addClass("hidden");
                    var id = treeNode.id;
                    bumpService.metaGetList(id).then(data => {
                        const json = data.data;
                        console.log(json)
                        json.code == undefined ? $("#code").val("") : $("#code").val(json.code);
                        json.id == undefined ? $("#id").val("") : $("#id").val(json.id);
                        json.parentId == undefined ? $("#parentId").val("") : $("#parentId").val(json.parentId);
                        json.name == undefined ? $("#name").val("") : $("#name").val(json.name);
                        json.level == undefined ? $("#level").val("") : $("#level").val(json.level);
                        json.accuracy == undefined ? $("#accuracy").val("") : $("#accuracy").val(json.accuracy);
                        json.byteNum == undefined ? $("#byteNum").val("") : $("#byteNum").val(json.byteNum);
                        json.dvcTypeId == undefined ? $("#dvcTypeId").val(1) : $("#dvcTypeId").val(json.dvcTypeId);
                        json.metaUnit == undefined ? $("#metaUnit").val("") : $("#metaUnit").val(json.metaUnit);
                        json.isEntity == undefined ? $("#isEntity").val(1) : $("#isEntity").val(json.isEntity);
                        json.value == undefined ? $("#value").val("") : $("#value").val(json.value);
                        json.format == undefined ? $("#format").val("") : $("#format").val(json.format);
                        json.deviationVal == undefined ? $("#deviationVal").val("") : $("#deviationVal").val(json.deviationVal);
                        json.hasExp == undefined ? $("#hexConvert").val(1) : $("#hexConvert").val(json.hexConvert);
                        json.linkSign == undefined ? $("#linkSign").val("") : $("#linkSign").val(json.linkSign);
                    })
                } else {
                    $("#editDiv").addClass("hidden");
                    $("#addDiv").removeClass("hidden");
                    $("#idAdd").val(treeNode.id);
                    $("#nameAdd").val(treeNode.name);
                    $("#levelAdd").val(treeNode.level);
                    $("#parentIdAdd").val(treeNode.pId);
                }
            }
        }, 0);
        return false;
    }

    beforeRemove(treeId, treeNode) {
        className = (className === "dark" ? "" : "dark");
        var zTree = $.fn.zTree.getZTreeObj("treeDemo");
        zTree.selectNode(treeNode);
        return confirm("确认删除 节点 -- " + treeNode.name + " 吗？");
    }

    onRemove(e, treeId, treeNode) {
        if (treeNode.id < 100000) {
            const id = treeNode.id;
            bumpService.metaDel(id).then(data => {
                if (data.code == 8001) {
                    this.setState({
                        expandId: "",
                    })
                    $("#editDiv").addClass("hidden");
                    $("#addDiv").addClass("hidden");
                    $("#success_msg").text(data.msg);
                    $("#success_tip").removeClass("hidden");
                    setTimeout(function () {
                        $("#success_tip").addClass("hidden");
                    }, 3000);
                } else {
                    $("#error_msg").text(data.msg);
                    $("#error_tip").removeClass("hidden");
                    setTimeout(function () {
                        $("#error_tip").addClass("hidden");
                    }, 3000);
                }
            })
        }
        return;
    }

    beforeRename(treeId, treeNode, newName, isCancel) {
        className = (className === "dark" ? "" : "dark");
        if (newName.length == 0) {
            setTimeout(function () {
                var zTree = $.fn.zTree.getZTreeObj("treeDemo");
                zTree.cancelEditName();
                alert("节点名称不能为空.");
            }, 0);
            return false;
        }
        return true;
    }

    onRename(e, treeId, treeNode, isCancel) {
        return;
    }

    showRemoveBtn(treeId, treeNode) {
        return !(treeNode.id == 1);
    }

    getTime() {
        var now = new Date(),
            h = now.getHours(),
            m = now.getMinutes(),
            s = now.getSeconds(),
            ms = now.getMilliseconds();
        return (h + ":" + m + ":" + s + " " + ms);
    }

    addHoverDom(treeId, treeNode) {
        var sObj = $("#" + treeNode.tId + "_span");
        if (treeNode.editNameFlag || $("#addBtn_" + treeNode.tId).length > 0) return;
        var addStr = "<span class='button add' id='addBtn_" + treeNode.tId + "' title='add node' onfocus='this.blur();'></span>";
        sObj.after(addStr);
        var btn = $("#addBtn_" + treeNode.tId);
        if (btn) btn.bind("click", function () {
            var zTree = $.fn.zTree.getZTreeObj("treeDemo");
            zTree.addNodes(treeNode, {
                id: 100000 + newCount,
                pId: treeNode.id,
                name: "new node" + (newCount++),
            });
            return false;
        });
    };

    removeHoverDom(treeId, treeNode) {
        $("#addBtn_" + treeNode.tId).unbind().remove();
    };

    submit(event) {
        event.preventDefault();
        const arr = {
            "code": $("#code").val(),
            "name": $("#name").val(),
            "parentId": $("#parentId").val(),
            "level": $("#level").val(),
            "accuracy": $("#accuracy").val(),
            "byteNum": $("#byteNum").val(),
            "dvcTypeId": $("#dvcTypeId").val(),
            "metaUnit": $("#metaUnit").val(),
            "isEntity": $("#isEntity").val(),
            "format": $("#format").val(),
            "deviationVal": $("#deviationVal").val(),
            "hexConvert": $("#hexConvert").val(),
            "linkSign": $("#linkSign").val(),
            "id": $("#id").val(),
            "value": $("#value").val(),
        };
        var data = JSON.stringify(arr)
        bumpService.metaInsertOrUpdate({data}).then(body => {

            if (body.code == 8001) {
                this.setState({
                    expandId: arr.id
                }, () => {
                    this.getData();
                    $("#success_msg").text(body.msg);
                    $("#success_tip").removeClass("hidden");
                    $("#success_tip").focus();
                    setTimeout(function () {
                        $("#success_tip").addClass("hidden");
                    }, 3000);
                })

            } else {
                $("#error_msg").text(body.msg);
                $("#error_tip").removeClass("hidden");
                $("#error_tip").focus();
                setTimeout(function () {
                    $("#error_tip").addClass("hidden");
                }, 3000);
            }
        })
    }

    submitAdd(event) {
        event.preventDefault();
        const url = this.state.url + "/meta/doEdit";
        const arr = {
            "code": $("#codeAdd").val(),
            "name": $("#nameAdd").val(),
            "parentId": $("#parentIdAdd").val(),
            "level": $("#levelAdd").val(),
            "accuracy": $("#accuracyAdd").val(),
            "byteNum": $("#byteNumAdd").val(),
            "dvcTypeId": $("#dvcTypeIdAdd").val(),
            "metaUnit": $("#metaUnitAdd").val(),
            "isEntity": $("#isEntityAdd").val(),
            "format": $("#formatAdd").val(),
            "deviationVal": $("#deviationValAdd").val(),
            "hexConvert": $("#hexConvertAdd").val(),
            "linkSign": $("#linkSignAdd").val(),
            "value": $("#valueAdd").val(),
        };
        var data = JSON.stringify(arr);
        bumpService.metaInsertOrUpdate({data}).then(body => {
            console.log(body)
            if (body.code == 8001) {
                this.setState({
                    expandId: body.data
                }, () => {
                    this.getData();
                    $("#success_msg").text(body.msg);
                    $("#success_tip").removeClass("hidden");
                    $("#success_tip").focus();
                    setTimeout(function () {
                        $("#success_tip").addClass("hidden");
                    }, 3000);
                })
            } else {
                $("#error_msg").text(body.msg);
                $("#error_tip").removeClass("hidden");
                $("#error_tip").focus();
                setTimeout(function () {
                    $("#error_tip").addClass("hidden");
                }, 3000);
            }
        })
        // $.ajax({
        // 	type: "POST",
        // 	url: url,
        // 	contentType: "application/json;charset=UTF-8",
        // 	data: JSON.stringify(data),
        // 	success: function(data) {
        // 		if (data.code == 8001) {
        // 			this.getData();
        // 			$("#success_msg").text(data.msg);
        // 			$("#success_tip").removeClass("hidden");
        // 			setTimeout(function() {
        // 				$("#success_tip").addClass("hidden");
        // 			}, 3000);
        // 		} else {
        // 			$("#error_msg").text(data.msg);
        // 			$("#error_tip").removeClass("hidden");
        // 			setTimeout(function() {
        // 				$("#error_tip").addClass("hidden");
        // 			}, 3000);
        // 		}
        // 	}.bind(this),
        // 	error: function(data) {
        // 		console.log("Get Area info error");
        // 	}.bind(this),
        // });

    }

    render() {
        const dvcTypes = this.state.dvcTypes.map(function (str, index) {
            return <option value={str.id} key={index}>{str.name}</option>
        });
        const hexConvert = [];
        const hexconverts = this.state.hexconverts;
        for (var prop in hexconverts) {
            if (hexconverts.hasOwnProperty(prop)) {
                const arr = {
                    "id": prop,
                    "name": hexconverts[prop]
                }
                hexConvert.push(arr);
            }
        }
        const hexConvertList = hexConvert.map(function (str, index) {
            return <option value={str.id} key={index}>{str.name}</option>
        })
        const isEnitity = [];
        const isEntitys = this.state.isEntitys;
        for (var prop in isEntitys) {
            if (isEntitys.hasOwnProperty(prop)) {
                const arr = {
                    "id": prop,
                    "name": isEntitys[prop]
                }
                isEnitity.push(arr);
            }
        }
        const isEnitityList = isEnitity.map(function (str, index) {
            return <option value={str.id} key={index}>{str.name}</option>
        })
        return (
            <div >
                <section className="content-header ">
                    <h1> {language()['BasicConfiguration']}
                        <small>{language()['ModelCreation']}</small>
                    </h1>
                </section>
                <section className="content">
                    <div className="box box-primary color-palette-box">
                        <div className="box-header with-border">
                            <i className="fa fa-list"></i>
                            <h3 className="box-title">{language()['ModelCreation']}</h3>

                        </div>
                        <div className="box-body">
                            <Tip ids=""/>
                            <div className=" col-sm-4">
                                <input type="hidden" id="nodes"/>
                                <ul id="treeDemo" className="ztree" style={{width: "260px"}}></ul>
                            </div>

                            <div className="col-sm-8 hidden" id="editDiv">
                                <form id="editForm" className="form-horizontal">
                                    {/********模型类别*************/}
                                    <div className="col-md-offset-1">
                                        <div className="form-group">
                                            <label htmlFor="name"
                                                   className="col-sm-3 control-label"> {language()['ModelCategory']}
                                            </label>
                                            <div className="col-sm-4 col-md-offset-1">
                                                <select id="dvcTypeId" name="dvcTypeId"
                                                        className="form-control col-sm-4">
                                                    {dvcTypes}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <ZtreeInput id="level" name="level"/>
                                    {/********父类ID*************/}
                                    <ZtreeInput id="parentId" name="parentId"/>
                                    {/********ID*************/}
                                    <ZtreeInput id="id" name="ID"/>
                                    {/**********编码***********/}
                                    <ZtreeInput id="code" name="code"/>
                                    {/********名称*************/}
                                    <ZtreeInput id="name" name="name"/>
                                    {/********值*************/}
                                    <ZtreeInput id="value" name="value"/>
                                    {/********协议字节数*************/}
                                    <ZtreeInput id="byteNum" name="byteNum"/>
                                    {/********精度*************/}
                                    <ZtreeInput id="accuracy" name="accuracy"/>
                                    {/********偏移量*************/}
                                    <ZtreeInput id="deviationVal" name="deviationVal" intNumber='true' />
                                    {/********数据格式*************/}
                                    <ZtreeInput id="format" name="format"/>
                                    {/********连接符*************/}
                                    <ZtreeInput id="linkSign" name="linkSign"/>
                                    {/********进制换算*************/}
                                    <div className="col-md-offset-1">
                                        <div className="form-group">
                                            <label htmlFor="name"
                                                   className="col-sm-3 control-label"> {language()['hexConvert']}
                                            </label>
                                            <div className="col-sm-4 col-md-offset-1">
                                                <select id="hexConvert" name="hexConvert"
                                                        className="form-control col-sm-4">
                                                    {hexConvertList}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    {/********是否为实体属性*************/}
                                    <div className="col-md-offset-1">
                                        <div className="form-group">
                                            <label htmlFor="name"
                                                   className="col-sm-3 control-label"> {language()['isEntity']}
                                            </label>
                                            <div className="col-sm-4 col-md-offset-1">
                                                <select id="isEntity" name="isEntity" className="form-control col-sm-4">
                                                    {isEnitityList}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    {/********单位*************/}
                                    <ZtreeInput id="metaUnit" name="metaUnit"/>
                                </form>
                                <div className="panel-body"></div>
                                <div className="col-sm-10 col-md-offset-1">
                                    <div className="col-sm-3"></div>
                                    <div className="col-sm-3 text-center">
                                        <button className="btn btn-success"
                                                onClick={this.submit}>{language()['submit']}</button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-8 hidden" id="addDiv">
                                <form id="addForm" className="form-horizontal">
                                    {/********模型类别*************/}
                                    <div className="col-md-offset-1">
                                        <div className="form-group">
                                            <label htmlFor="name"
                                                   className="col-sm-3 control-label"> {language()['ModelCategory']}
                                            </label>
                                            <div className="col-sm-4 col-md-offset-1">
                                                <select id="dvcTypeIdAdd" name="dvcTypeIdAdd"
                                                        className="form-control col-sm-4">
                                                    {dvcTypes}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    {/********级别*************/}
                                    <ZtreeInput id="levelAdd" name="level"/>
                                    {/********父类ID*************/}
                                    <ZtreeInput id="parentIdAdd" name="parentId"/>
                                    {/********ID*************/}
                                    <ZtreeInput id="idAdd" name="ID"/>
                                    {/**********编码***********/}
                                    <ZtreeInput id="codeAdd" name="code"/>
                                    {/********名称*************/}
                                    <ZtreeInput id="nameAdd" name="name"/>
                                    {/********值*************/}
                                    <ZtreeInput id="valueAdd" name="value"/>
                                    {/********协议字节数*************/}
                                    <ZtreeInput id="byteNumAdd" name="byteNum"/>
                                    {/********精度*************/}
                                    <ZtreeInput id="accuracyAdd" name="accuracy"/>
                                    {/********偏移量*************/}
                                    <ZtreeInput id="deviationValAdd" name="deviationVal" intNumber='true'/>
                                    {/********数据格式*************/}
                                    <ZtreeInput id="formatAdd" name="format"/>
                                    {/********连接符*************/}
                                    <ZtreeInput id="linkSignAdd" name="linkSign"/>
                                    {/********进制换算*************/}
                                    <div className="col-md-offset-1">
                                        <div className="form-group">
                                            <label htmlFor="name"
                                                   className="col-sm-3 control-label"> {language()['hexConvert']}
                                            </label>
                                            <div className="col-sm-4 col-md-offset-1">
                                                <select id="hexConvertAdd" name="hexConvertAdd"
                                                        className="form-control col-sm-4">
                                                    {hexConvertList}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    {/********是否为实体属性*************/}
                                    <div className="col-md-offset-1">
                                        <div className="form-group">
                                            <label htmlFor="name"
                                                   className="col-sm-3 control-label"> {language()['isEntity']}
                                            </label>
                                            <div className="col-sm-4 col-md-offset-1">
                                                <select id="isEntityAdd" name="isEntityAdd" className="form-control col-sm-4">
                                                    {isEnitityList}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    {/********单位*************/}
                                    <ZtreeInput id="metaUnitAdd" name="metaUnit"/>
                                </form>
                                <div className="panel-body"></div>
                                <div className="col-sm-10 col-md-offset-1">
                                    <div className="col-sm-3"></div>
                                    <div className="col-sm-3 text-center">
                                        <button className="btn btn-success"
                                                onClick={this.submitAdd}>{language()['submit']}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./modules/bump/config/meta/metaIndex.js